import * as lunr from "lunr";

export class Index {
    idMap: { [id: string]: string }
    idx: lunr.Index
    constructor(data: { idMap: any, idx: object }) {
        this.idMap = data.idMap
        this.idx = lunr.Index.load(data.idx)
    }
    search(term: string): lunr.Index.Result[] {
        return this.idx.search(term)
    }
    static async load(uri: string): Promise<Index> {
        const resp = await fetch(uri)
        if (resp.ok) {
            return new Index(await resp.json())
        }
        throw new Error('Failed to load index.')
    }
}